export enum DataStatus {
  UNINIT = 'UNINIT',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  OK = 'OK',
  BUSY = 'BUSY'
}

